<template>
  <div v-if="!isCallingUsers">
    <div class="UserDet d-flex">
      <div class="User User--detail flex-shrink-0">
        <user-name-badge
          :userName="fullUserName"
          :userAvatarId="userProfilePictureId"
          :classList="'user-badge-large'"
        ></user-name-badge>
      </div>
      <div class="UserDet-block">
        <h1
          class="Tit Tit--userDet"
          v-if="fullUserName"
        >{{fullUserName}}</h1>
        <div class="UserDet-info d-flex flex-wrap"><span
            class="UserDet-infoItm"
            v-if="userEmail"
          >{{userEmail}}</span><span
            v-if="userPhoneAndPrefix"
            class="UserDet-infoItm"
          >{{userPhoneAndPrefix}}</span><span
            class="UserDet-infoItm"
            v-if="userRole"
          >{{userRoleLabel}}</span><span
            class="UserDet-infoItm"
            :class="userStatusClass"
            v-if="userStatus.statusType"
          >{{ $t(`user_status__${userStatus.statusType.code}`)}}</span></div>
      </div>
    </div>
    <div class="SecActions d-flex flex-nowrap">
      <!-- Cancel invitation -->
      <a
        class="SecActions-link SecAction-link--remove"
        v-if="showCancelInvitationButton"
        href="#"
        @click.prevent="showConfirmModal"
      >{{$t(cancelUserButtonLabel)}}</a>

    </div>

    <div class="d-flex flex-grow-1 flex-md-grow-0">

      <ul class="Submenu d-flex mb-0">
        <li class="Submenu-itm">
          <router-link
            class="Submenu-itmLink"
            active-class="Submenu-itmLink--curr"
            :to="`/users/detail/${userId}/cards`"
            v-t="{path: 'user_detail_tab_member_cards'}"
          ></router-link>
        </li>
        <li class="Submenu-itm">
          <router-link
            class="Submenu-itmLink"
            active-class="Submenu-itmLink--curr"
            :to="`/users/detail/${userId}/budgets`"
            v-t="{path: 'user_detail_tab_budgets'}"
          ></router-link>
        </li>
        <li class="Submenu-itm">
          <router-link
            class="Submenu-itmLink"
            active-class="Submenu-itmLink--curr"
            :to="`/users/detail/${userId}/transactions`"
            v-t="{path: 'user_detail_tab_transactions'}"
          ></router-link>
        </li>
        <li class="Submenu-itm">
          <router-link
            class="Submenu-itmLink"
            active-class="Submenu-itmLink--curr"
            :to="`/users/detail/${userId}/reimbursements`"
            v-t="{path: 'user_detail_tab_reimbursements'}"
          ></router-link>
        </li>
        <li
          class="Submenu-itm"
          v-if="hasBenefitsActivated && !userIsBook && !isSuperAdmin"
        >
          <router-link
            class="Submenu-itmLink"
            active-class="Submenu-itmLink--curr"
            :to="`/users/detail/${userId}/benefits`"
            v-t="{path: 'user_detail_tab_benefits'}"
          ></router-link>
        </li>
      </ul>
    </div>

    <div class="py-5">
      <router-view></router-view>
    </div>
    <confirm-modal
      :id="'confirm-archive-modal'"
      v-if="showConfimArchiveModalFlag"
      :open.sync="showConfimArchiveModalFlag"
      :title="confirmToggleUserStatusHeaderLabel"
      :message="''"
      ignoreDefaultMessage
      :acceptText="confirmToggleUserStatusActionLabel"
      :dismissText="'ACTION_CANCEL'"
      @accept="toggleUserStatus"
    >
      <template
        v-slot:additional
        :extraInfo="fullUserName"
      >
        <i18n
          tag="span"
          :path="confirmToggleUserStatusMessageLabel"
        >
          <template v-slot:user>
            <span class="text-primary">{{fullUserName}}</span>
          </template>
        </i18n>

      </template>
    </confirm-modal>
    <confirm-modal
      :id="'confirm-remove-modal'"
      v-if="showConfirmModalFlag"
      :title="cancelUserButtonLabel"
      :message="''"
      ignoreDefaultMessage
      :acceptText="cancelUserButtonLabel"
      :dismissText="'ACTION_CANCEL'"
      :open.sync="showConfirmModalFlag"
      @accept="cancelInvitation"
      @dismissCancel="hideConfirmModal"
    >
      <template
        v-slot:additional
        :extraInfo="fullUserName"
      >
        <i18n
          tag="span"
          class="Fuell-Text"
          :path="'users_actions_confirm_modal_message'"
        >
          <template v-slot:action>
            <span>{{$t(cancelOrRemoveUserActionLabel)}}</span>
          </template>

          <template v-slot:user>
            <span class="text-primary">{{fullUserName}}</span>
          </template>
          <template v-slot:email>
            <span class="text-primary"> {{userEmail}}</span>
          </template>
        </i18n>

      </template>

    </confirm-modal>

  </div>
  <div
    style="height:75vh;"
    class="w-100 d-flex justify-content-center align-items-center my-auto"
    v-else
  >
    <spinner />
  </div>
</template>

<script>
import _userDetailHandler from '../../_mixins/_userDetailHandler'
import _userRoleHandlerMixin from '../../_mixins/_userRoleHandlerMixin'

import UserNameBadge from '@/components/Commons/UserNameBadge'
import Spinner from '@/components/Commons/Spinner'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'UserDetailIndex',
  mixins: [
    _userDetailHandler, _userRoleHandlerMixin
  ],
  components: { UserNameBadge, ConfirmModal, Spinner },
  data () {
    return {
      showConfirmModalFlag: false,
      showConfimArchiveModalFlag: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['UsersStore/user']
    },
    isCallingUsers () {
      return this.$store.getters['UsersStore/isCallingUsers']
    },
    userProfilePictureId () {
      return this.user && this.user.profilePicture ? this.user.profilePicture.id : 0
    },
    userStatusToggleLabel () {
      return this.userStatus.active ? 'user_detail_action_archive_user' : 'user_detail_action_activate_user'
    },
    userPending () {
      if (this.userStatus) {
        return ['INVITE_BY_ADMIN', 'INVITE_BY_SUPER_ADMIN'].includes(this.userStatus.statusType.code)
      }
      return false
    },
    confirmModalMessageLabel () {
      return 'users_actions_confirm_modal_message'
    },
    confirmToggleUserStatusMessageLabel () {
      return this.userStatus.statusType.code === 'ACTIVE' ? 'user_detail_toggle_status_confirm_archive_warning' : 'user_detail_toggle_status_confirm_restore_warning'
    },
    confirmToggleUserStatusHeaderLabel () {
      return this.userStatus.statusType.code === 'ACTIVE' ? 'user_detail_toggle_status_confirm_archive_header_action' : 'user_detail_toggle_status_confirm_restore_header_action'
    },
    confirmToggleUserStatusActionLabel () {
      return this.userStatus.statusType.code === 'ACTIVE' ? 'user_detail_toggle_status_confirm_archive_header_action' : 'user_detail_toggle_status_confirm_restore_header_action'
    },
    cancelOrRemoveUserActionLabel () {
      return this.userPending ? 'user_action_cancel_invitation_warning' : 'user_action_remove_warning'
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    cancelUserButtonLabel () {
      return this.userPending ? 'users_confirm_cancel_invitation_header' : 'users_confirm_remove_user_header'
    },
    showToggleUserStatus () {
      if (!this.userPending) {
        return !this.userIsAdminOwner && !this.userIsSuperAdmin && !this.userIsCurrentLoggedUser
      } else {
        return false
      }
    },
    showCancelInvitationButton () {
      if (this.isSuperAdmin) {
        return true
      }

      return this.$store.getters['LoginStore/isAdmin'] ? this.userIsBook || this.userIsRegular : false
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany'] || {}
    },
    hasBenefitsActivated () {
      if (this.isSuperAdmin) {
        return false
      }
      const hasFlexibleRemuneration = this.currentCompany.activatedFeatures.findIndex(el => el.feature.code === 'FLEXIBLE_REMUNERATION')

      return hasFlexibleRemuneration > -1
    }
  },
  methods: {
    handleToggleUserStatus () {
      this.showConfirmToggleUserStatus()
    },

    toggleUserStatus () {
      this.userStatus.active ? this.$store.dispatch('UsersStore/archiveUser', this.userId) : this.$store.dispatch('UsersStore/activateUser', this.userId)
    },
    showConfirmModal () {
      this.showConfirmModalFlag = true
    },
    showConfirmToggleUserStatus () {
      this.showConfimArchiveModalFlag = true
    },
    hideConfirmModal () {
      this.showConfirmModalFlag = false
    },
    async cancelInvitation () {
      await this.$store.dispatch('UsersStore/removeUser', { userId: this.userId, user: this.user })
      if (this.isSuperAdmin) {
        this.$router.push('/customers')
      } else {
        this.$router.push('/users')
      }
    },

    async fetchUser () {
      await this.$store.dispatch('UsersStore/fetchUser', this.userId)
    }

  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      await vm.fetchUser()

      if (to.name === 'user_benefits') {
        if (vm.hasBenefitsActivated && vm.userIsBook === false) {
          next()
        } else {
          next('/users')
        }
      }
    })
  }

}
</script>

<style scoped>
.User--detail {
  margin: 0px 20px 24px 0px;
}
.user-badge-large {
  flex: 0 0 100% !important;
  height: 100% !important;
  font-size: 1.8em !important;
}
.SecAction-link--remove {
  background-color: var(--semantic-alert-main);
  color: var(--text-button);
  opacity: 1;
}
.SecActions {
  right: 65px;
}
</style>
